export default {
    ffa: {
        requiresTeamSize: false,
        display: 'FFA'
    },
    chosen: {
        requiresTeamSize: true,
        display: 'Chosen'
    },
    random: {
        requiresTeamSize: true,
        display: 'Random'
    },
    picked: {
        display: 'Picked',
        requiresTeamSize: true
    },
    market: {
        display: 'Auction',
        requiresTeamSize: false
    },
    mystery: {
        display: 'Mystery',
        requiresTeamSize: true
    },
    rvb: {
        display: 'Red vs Blue',
        requiresTeamSize: false
    },
    captains: {
        display: 'Captains',
        requiresTeamSize: true
    }
};



// WEBPACK FOOTER //
// ./src/services/TeamStyles.js